import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { JobsToBeDoneDetail, JobsToBeDoneResponse } from 'app/client-core/dtos/jtdb-dto.model';
import { ProgramService } from 'app/client-core/services/program.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-jobs-to-be-done-details',
  templateUrl: './jobs-to-be-done-details.component.html',
  styleUrls: ['./jobs-to-be-done-details.component.scss']
})
export class JobsToBeDoneDetailsComponent implements OnInit, OnChanges {
  jobsToBeDoneResult: JobsToBeDoneResponse = {} as JobsToBeDoneResponse;
  selectedDetails: JobsToBeDoneDetail = null;
  submitted: boolean;
  
  @Input() canEdit: boolean;
  @Input() programId: number;
  @Input() jobsToBeDoneHeaderIds: string;
  @Output() canShowChanged = new EventEmitter();
  detailsOpened = true;
  programServiceSubscription: Subscription;

  constructor(
    private programService: ProgramService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('loading jobs to be done', changes)
    if (this.canEdit) {
      this.loadDetails(); 
    } else {
      this.jobsToBeDoneResult = {} as JobsToBeDoneResponse;
    }
  }

  ngOnInit() {
  }

  loadDetails() {
    console.log('loadDetails() this.programId ', this.programId)
    if (this.programServiceSubscription) {
      this.programServiceSubscription.unsubscribe();
    }
    this.programServiceSubscription = this.programService.getJobsToBeDoneDetails(this.jobsToBeDoneHeaderIds, this.programId).subscribe(res => {
      this.jobsToBeDoneResult = res.data;
      if (this.jobsToBeDoneResult.id) {
        this.selectedDetails = this.jobsToBeDoneResult.jobsToBeDoneDetails.find(j => j.id == this.jobsToBeDoneResult.id);
      }
      this.canShowChanged.emit(this.jobsToBeDoneResult.canShow == 1);
    })
  }

  jobsToBeDoneSelected() {
    if (this.selectedDetails) {
      this.jobsToBeDoneResult.id = this.selectedDetails.id;
      this.jobsToBeDoneResult.description = this.selectedDetails.description;
      this.jobsToBeDoneResult.brands = this.selectedDetails.brands;
    } else {
      this.jobsToBeDoneResult.id = null;
      this.jobsToBeDoneResult.description = '';
      this.jobsToBeDoneResult.brands = '';
    }
    
    console.log(this.jobsToBeDoneResult);
  }

  save(programId?) {
    return new Promise((resolve, reject) => {
      if (!this.isDetailsValid()) {
        reject(new Error("There were some validation errors"));
      }
      if (!this.programId && !programId) {
        resolve();
        return;
      }
      this.jobsToBeDoneResult.programId = programId || this.programId;
      this.programService.saveJobsToBeDoneDetails(this.jobsToBeDoneResult).subscribe(() => {
        resolve();
      }, error => {
        reject(error);
      });
    });
  }

  isDetailsValid() {
    if (!this.selectedDetails) {
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/jobs-to-be-done-details/jobs-to-be-done-details.component.ts